import axios from 'axios'
import { Loading, Message } from 'element-ui'
import router from '@/router'

let loadingInstance = null
let requestCount = 0

function showLoading() {
  requestCount++
  if (requestCount === 1) {
    loadingInstance = Loading.service({
      fullscreen: true,
      text: '加载中...',
      background: 'rgba(0,0,0,0.3)'
    })
  }
}

function hideLoading() {
  requestCount--
  if (requestCount <= 0) {
    requestCount = 0
    if (loadingInstance) {
      loadingInstance.close()
      loadingInstance = null
    }
  }
}

const request = axios.create({
  baseURL: '/'
})

request.interceptors.request.use(config => {
  const token = localStorage.getItem('token')
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  showLoading()
  return config
})

request.interceptors.response.use(
  response => {
    hideLoading()
    return response.data
  },
  error => {
    hideLoading()
    const status = error.response?.status
    if (status === 401) {
      localStorage.removeItem('token')
      router.push('/login')
      Message.error('登录已过期，请重新登录')
    } else if (status === 400 && error.response.data?.error) {
      Message.error(error.response.data.error)
    }
    return Promise.reject(error)
  }
)

export default request